export enum ELoginFormItem {
    EMAIL = "EMAIL",
    PASSWORD = "PASSWORD",
}
